import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-dialog-title', {
    fontSize: '20px',
    fontWeight: 'normal',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    marginBottom: '18px',
});

cssRule('.tb-dialog-title.are-you-really-sure', {
    textAlign: 'center',
    fontWeight: 'bold',
});

cssRule('.tb-dialog-body-text', {
    wordWrap: 'break-word',
    lineHeight: '1.5em',
});

cssRule('.tb-dialog-body-text.are-you-really-sure', {
    textAlign: 'center',
});

cssRule('.tb-dialog-description', {
    fontSize: '12px',
    marginBottom: '18px',
    wordWrap: 'break-word',
});

cssRule('.tb-dialog-actions', {
    marginTop: '13.5px',
    whiteSpace: 'nowrap',
    textAlign: 'right',
});

cssRule('.tb-dialog-actions.are-you-really-sure', {
    textAlign: 'center',
});

cssRule('.tb-dialog-error', {
    marginTop: '12px',
    color: applyColor(DesignTokens.color.font.default.error, '#c41723'),
});

cssRule('.tb-dialog-body-input', {
    width: '100%',
    marginTop: '12px',
});

cssRule('.tb-dialog-body-control', {
    marginTop: '12px',
});

cssRule('.tb-alert-message', {
    marginBottom: '12px',
});

cssRule('.tb-dialog-body-input-description', {
    marginBottom: '6px',
    wordWrap: 'break-word',
});

cssRule('.tb-checkbox-group-outside', {
    position: 'absolute',
    top: 'auto',
    right: 0,
    bottom: 'auto',
    left: 'auto',
    color: applyColor(DesignTokens.color.font.inverse.default, '#fff'),
});

